export class EntLeasingRegisterFilter {

  page: number;
  size: number;
  transportIds: number[] | null;
  operatorIds: number[] | null;
  projectIds: number[] | null;
  deleted?: boolean | null;

  constructor(init?:Partial<EntLeasingRegisterFilter>) {
    this.deleted = false;
    this.transportIds = null;
    this.projectIds = null;
    this.operatorIds = null;
    this.page = 1;
    this.size = 30;
    if(init){
      Object.assign(this, init)
    }
  }
}
